export default import.meta.ROLLDOWN_FILE_URL_zEQVROJXQ2oFT2lc4JnEpw